import React from "react";
import { Link } from "react-router-dom";

export default function Nav() {
  const [open, setOpen] = React.useState(false);
  return (
    <div className="nav-wrap">
      <nav className="nav-glass">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-5 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3" data-testid="nav-logo">
            <img src="https://customer-assets.emergentagent.com/job_creative-freedom-ai-1/artifacts/xmezblsi_Logo.jpeg" alt="Freedom By AI Design" className="h-12 md:h-14 w-auto"/>
          </Link>
          <div className="hidden md:flex items-center gap-10">
            <Link to="/#solutions" className="text-xs uppercase tracking-[0.18em] text-secondary hover:text-primary transition-colors" data-testid="nav-solutions">Solutions</Link>
            <Link to="/#industries" className="text-xs uppercase tracking-[0.18em] text-secondary hover:text-primary transition-colors" data-testid="nav-industries">Industries</Link>
            <Link to="/#pricing" className="text-xs uppercase tracking-[0.18em] text-secondary hover:text-primary transition-colors" data-testid="nav-pricing">Pricing</Link>
            <Link to="/#audit" className="text-xs uppercase tracking-[0.18em] text-secondary hover:text-primary transition-colors" data-testid="nav-audit">AI Audit</Link>
            <Link to="/#about" className="text-xs uppercase tracking-[0.18em] text-secondary hover:text-primary transition-colors" data-testid="nav-about">About</Link>
            <a href="https://calendly.com/freedombyaidesign" target="_blank" rel="noopener noreferrer" className="btn-primary" data-testid="nav-book-cta">Book a Call</a>
          </div>
          <button onClick={() => setOpen(!open)} className="md:hidden text-primary" data-testid="nav-mobile-toggle">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><path d="M3 6h18M3 12h18M3 18h18"/></svg>
          </button>
        </div>
        {open && (
          <div className="md:hidden border-t border-white/5 px-6 py-6 flex flex-col gap-4 bg-base">
            <Link to="/#solutions" onClick={()=>setOpen(false)} className="text-sm uppercase tracking-widest text-secondary">Solutions</Link>
            <Link to="/#industries" onClick={()=>setOpen(false)} className="text-sm uppercase tracking-widest text-secondary">Industries</Link>
            <Link to="/#pricing" onClick={()=>setOpen(false)} className="text-sm uppercase tracking-widest text-secondary">Pricing</Link>
            <Link to="/#audit" onClick={()=>setOpen(false)} className="text-sm uppercase tracking-widest text-secondary">AI Audit</Link>
            <Link to="/#about" onClick={()=>setOpen(false)} className="text-sm uppercase tracking-widest text-secondary">About</Link>
          </div>
        )}
      </nav>
    </div>
  );
}
